import playerInfoStore from "../store/playerInfos";


// Custom hook để sử dụng và cập nhật cấu hình player
const usePlayerInfo = (playerId) => {
    const playerInfos = playerInfoStore((state) => state.playerInfos);
    const updatePlayer = playerInfoStore((state) => state.updatePlayer);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        playerInfo: playerId == null ? {} : playerInfos[playerId] || {}, // Nếu không có playerId, trả về object rỗng
        playerInfos,
        updatePlayer,
    };
};

export default usePlayerInfo;
